<template>
  <div :id="`users_category_${modalNumber}`" class="modal fade rtl" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <p class="font-weight-bold">لیست کاربران دسته بندی {{ category.title }}</p>
        </div>
        <div class="modal-body">
          <div class="mb-5 mt-3">
            <div
                v-for="(user, index) in users"
                :key="index"
            >
              <div
                  class="bg-white shadow-sm d-flex justify-content-between align-items-center border mb-2"
                  style="border-radius: 10px;"
              >
                <div class="mx-3 font-weight-bold">{{ user.full_name }}</div>

                <button @click="deleteCategory(user.id)" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                  <i class="fa fa-trash text-danger"></i>
                </button>
              </div>
            </div>
          </div>

          <form
              :id="`users_category_form_${modalNumber}`"
              @submit.prevent="addUser"
          >
            <kt-row class="p-2">
              <kt-col lg="9" md="9">
                <kt-form-group>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                    <span class="input-group-text bg-white text-dark" id="basic-addon1"
                    >نام کامل کاربر
                      <span class="text-danger">*</span>
                    </span>
                    </div>
                    <v-select
                        v-model="selected_user"
                        name="user"
                        class="form-control vSelect"
                        :options="optionsUser"
                        :filterable="false"
                        @search="onSearchUser"
                        :getOptionLabel="(user) => user.id"
                    >
                      <template slot="no-options"> کاربر مورد نظر را انتخاب کنید </template>
                      <template slot="option" slot-scope="options">
                        <div class="d-flex align-items-center">
                          {{ options.full_name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="options">
                        <div class="selected d-flex align-items-center">
                          {{ options.full_name }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                </kt-form-group>
              </kt-col>

              <kt-col lg="3" md="3">
                <div class="form-group">
                  <button :id="`users_category_btn_${modalNumber}`" type="submit" class="btn btn-primary">
                    {{ $t('btn.add') }}
                  </button>
                </div>
              </kt-col>
            </kt-row>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import {ticketService} from "@/common/api.service";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import toastr from "toastr";

export default {
  name: "users-category-modal",
  props: {
    modalNumber: {
      required: true
    },
    category: {
      required: true
    },
    users: {
      required: true
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },
  },
  data() {
    return {
      selected_user: null,
      optionsUser: [],
    }
  },
  methods: {
    addUser() {
      let btn = $('#users_category_btn_' + this.modalNumber)

      if (!this.selected_user) {
        this.toastr.error('فیلد نام کاربر الزامی می باشد!')
        return;
      }

      KTApp.progress(btn)

      let data = {
        user_hashid: this.selected_user.id
      }

      ticketService.addUserToTicketCategory(data, this.category.id)
          .then((response) => {
            $('#users_category_' + this.modalNumber).modal('hide')
            this.selected_user = null
            this.toastr.success(response.data.message)
          })
          .catch(({response}) => {
            this.toastr.error(response.data.message)
          })
          .finally(() => {
            KTApp.unprogress(btn)
          })
    },
    onSearchUser(full_name, loading) {
      if (full_name.length > 2) {
        this.searchUser(loading, full_name, this)
      }
    },
    searchUser: _.debounce((loading, full_name, vm) => {
      if (full_name.length > 2) {
        ticketService.searchUser({
          full_name: full_name
        })
            .then((response) => {
              vm.optionsUser = response.data.data
              loading(false);
            })
      }
    }, 600),
    deleteCategory(user_id) {
      if (confirm('آیا از حذف این کاربر مطمئنید؟')){
        ticketService.deleteCategoryUser(user_id, this.category.id)
            .then(async (response) => {
              await ticketService.getCategoryUser(this.category.id)
                  .then((response) => {
                    this.users = response.data.data
                  })
              this.toastr.success(response.data.message)
            })
            .catch(({response}) => {
              this.toastr.error(response.data.message)
            })
      }
    },
  }
}
</script>

<style scoped>
.vSelect {
  --vs-actions-padding: 0;
  --vs-border-color: #fff;
}
</style>